<template>
  <el-dialog title="错敏检测" width="1200px" :visible.sync="misseIsShow" :before-close="close">
    <div class="content">
      <div class="left">
        <div class="title">
          <el-input v-model="title" placeholder="请输入文章标题" maxlength="50"></el-input>
        </div>
        <div class="abstract">
          <el-input v-model="abstractText" placeholder="摘要(选填)" maxlength="120" show-word-limit></el-input>
        </div>
        <!-- <div class="article">
            <el-input placeholder="文章内容" v-model="content" type="textarea" :rows="10">
            </el-input>
        </div> -->
        <uEditorWrap v-model="htmlContents"
                     @ready="ueditorReady"
                     editor-id="uEditor"
                     :config="uEditorConfig"
                     :editorDependencies="['ueditor.config.js','ueditor.all.js']"
                     style="min-height:400px"/>
        <!--                <Editor-->
        <!--                    style="min-height: 500px; overflow-y: hidden;padding: 10px"-->
        <!--                    v-model="htmlContents"-->
        <!--                    :defaultConfig="editorConfig"-->
        <!--                    :mode="mode"-->
        <!--                    @onCreated="onCreated"-->
        <!--                />-->
      </div>
      <div class="rgith">
        <div class="tips">检测助手</div>
        <div style="border: 1px solid #d9d9d9;border-top:none;min-height: 500px;">
          <div class="info">
            <div>共<span class="count">{{ allKeysLength }}</span>条建议</div>
            <div>
              <el-button @click="toCorrectionExtract" size="mini">重新检测</el-button>
              <el-button @click="toRevise" size="mini">全部修订</el-button>
            </div>
          </div>
          <div style="padding: 10px;height:445px;overflow-y: scroll;">
            <div v-for="(item,index) in allKeys" :key="index" :class="activeIndex===index?'item':'normal'" v-show="!item.disabled" @click="anchor(item,index)">
              <div style="width: 90%">
                <div class="top">
                <span style="color:#ff4020;font-weight: 400;">{{ item.error }}</span>
                <span class="el-icon-right" style="margin: 0 5px"></span>
                <span>{{ item.correct }}</span>
                </div>
                <div class="bottom" v-if="activeIndex===index">
                  错误类型：{{item.type}}
                </div>
              </div>
              <div @click.stop="toReviseOne(item,index)" class="mini">修订</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px;text-align: right;">
      <el-button style="padding:10px 24px" size="small" @click="close">取消</el-button>
      <el-button style="padding:10px 24px" size="small" type="primary" @click="toSave">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
// import { Editor} from '@wangeditor/editor-for-vue'
import uEditorWrap from "vue-ueditor-wrap";
import {textCorrectionExtract} from './manuscripts.js'
import {Loading} from "element-ui";

export default {
  components: {
    // Editor
    uEditorWrap
  },
  props: {
    misseIsShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    abstractText: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  watch:{
    allKeys:function(){
      let num=0;
      this.allKeys.map(item=>{
        if(!item.disabled){
          num++;
        }
      })
      this.allKeysLength=num;
    }
  },
  data() {
    return {
      uEditorConfig: {
        // 配置UEditorPlus的惊天资源
        UEDITOR_HOME_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        UEDITOR_CORS_URL: process.env.VUE_APP_Admin || '/admin/static/uEditor/',
        // 服务器统一请求接口路径
        serverUrl: process.env.VUE_APP_BASE_URL + "/site-service/m/cover/uploadImage"
        // 启用拖放上传
        , enableDragUpload: true
        // 启用粘贴上传
        , enablePasteUpload: true
        // 启用图片拉伸缩放
        , imageScaleEnabled: true
        //获取iframe元素，指定唯一name
        , name: "sensitivity"
      },
      uEditor: null,
      editor: null,
      toolbarConfig: {
        excludeKeys: [
          'todo',
          'emotion'
        ]
      },
      htmlContents: this.content,
      editorConfig: {
        placeholder: '请输入正文',
        pasteFilterStyle: false,
        MENU_CONF: {
          fontFamily: {
            fontFamilyList: [
              '仿宋_GB2312',
              '黑体',
              '仿宋',
              '楷体',
              '标楷体',
              '华文仿宋',
              '华文楷体',
              '宋体',
              '微软雅黑',
              'Arial',
              'Tahoma',
              'Verdana',
              'Times New Roman',
              'Courier New',
            ]
          },
          fontSize: {
            fontSizeList: [
              {name: '初号', value: '56px'},
              {name: '小初', value: '48px'},
              {name: '一号', value: '34px'},
              {name: '小一', value: '32px'},
              {name: '二号', value: '29px'},
              {name: '小二', value: '24px'},
              {name: '三号', value: '21px'},
              {name: '小三', value: '20px'},
              {name: '四号', value: '18px'},
              {name: '小四', value: '16px'},
              {name: '五号', value: '14px'},
              {name: '小五', value: '12px'},
            ]
          },
          lineHeight: {
            lineHeightList: ['1', '1.5', '2', '2.5', '3']
          },

          uploadImage: {
            server: 'http://192.168.1.10:8080/site-service/m/cover/uploadImage',
            fieldName: 'file',
            meta: {
              type: 'img',
            },
            headers: {
              token: sessionStorage.getItem('token'),
            },
            customInsert: this.customInsert
          }
        }
      },
      mode: 'default', // or 'simple'
      allKeys: [],
      isloding: false,
      isChange: false,
      allKeysLength:0,
      activeIndex:null,
    }
  },
  methods: {
    ueditorReady(editor) {
      this.uEditor = editor;
      this.toCorrectionExtract();
    },
    anchor(obj,index) {
      this.activeIndex=index;
      let dom = window.frames[this.uEditorConfig.name].document.getElementById(obj.index);
      dom.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    },
    close() {
      this.$emit('closeMisse')
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    customInsert(res, insertFn) {
      let url = this.imgIp + res.data.path
      let alt = res.data.name
      insertFn(url, alt, '')
    },
    toCorrectionExtract() {
      let loadingInstance1 = Loading.service({fullscreen: true});
      this.$nextTick(() => {
        const _this = this
        _this.allKeys = []
        //获取文本HTML内容--字符串
        let dom = _this.uEditor.getContent();
        //获取保留格式后文本内容--字符串
        let content = this.uEditor.getPlainTxt();
        // 获取整个富文本DOM对象--对象
        let domObj = new DOMParser().parseFromString(dom, "text/html").body;

        //如果当前“富文本”内容有表格，则过滤表格文本内容
        //后续如需过滤其他标签内的内容，可在此添加
        let content2="";
        let conFlag=false;
        for(let a=0; a<domObj.children.length; a++){
          if(domObj.children[a].tagName.toLowerCase()!=="table"){
            content2 += this.uEditor.getPlainTxt(domObj.children[a])+"\n";
          }else{
            conFlag=true;
          }
          // if(domObj.children[a].getAttribute("customedit")==="false"){
          //   content2 += this.uEditor.getPlainTxt(domObj.children[a])+"\n";
          // }
        }
        if(conFlag){
          content=content2
        }

        textCorrectionExtract({text: content}).then(res => {
          let errorWords = res.data;

          // 对错误单词进行标记
          for (let i = 0; i < errorWords.length; i++) {
            let errorWord = errorWords[i].error;
            let text = "";
            let preText = "";
            let nextText = "";
            let index = 0;
            let subscript = 0;
            //通过错词所在的句子找到当前下标，方便后续建立关系后找到对应文字在包含标签内容中的下标
            for (let j = 0; j < domObj.children.length; j++) {
              let domText = domObj.children[j].innerText.replace(/\s*/g,"");
              let errText = errorWords[i].text.replace(/\s*/g,"").replace(/&lt;/,"<").replace(/&gt;/,">");
              if (domText && domText !== " ") {
                if (domText.indexOf(errText) !== -1) {
                  index=j;
                  subscript = errText.lastIndexOf(errorWord)+domText.indexOf(errText)
                }else if (errText.indexOf(domText) !== -1) {
                  index=j;
                  subscript = errText.lastIndexOf(errorWord)
                }
              }
            }
            // 第一轮筛选（简单筛选），找不到下标进入第二轮
            if (errorWord.length > 2) {
              text = errorWord
            } else{
              if (content[errorWords[i].index - 1] !== " ") {
                preText = content[errorWords[i].index - 1]
              }
              if (content[errorWords[i].index + 1] !== " ") {
                nextText = content[errorWords[i].index + errorWord.length]
              }
              text = preText + errorWord + nextText
            }
            let domIndex=domObj.children[index].innerHTML.lastIndexOf(text);
            if(domObj.children[index].innerHTML === text){
              domIndex = 0;
            }
            // 处理特殊符号“<” 和 “>”，防止转义后，下标与实际长度不匹配
            domObj.children[index].innerHTML =  domObj.children[index].innerHTML.replace(/&lt;/,"<").replace(/&gt;/,">")
            // if(errorWord.length===1){
            //   console.log(text,domObj.children[index].innerHTML.indexOf(errorWords[i].text)+subscript)
            //   domIndex=domObj.children[index].innerHTML.indexOf(text);
            // }
            if(domIndex===-1&&errorWord.length===1){
              text=errorWord;
              domIndex=domObj.children[index].innerHTML.indexOf(text,subscript);
            }

            //第二轮筛选（建立一一对应关系），当错词长度为1时，需单独处理
            if(domIndex===-1||errorWord.length===1){
              let map=[];
              let length = 0;
              if(errorWords[i].text.length>domObj.children[index].innerText.length){
                length = errorWords[i].text.length
              }else{
                length = domObj.children[index].innerText.length
              }
              let start = 0;
              //根据节点内容与内容一一建立关系，后续可通过文本内容中一段话得到错敏的下标，从而得到富文本中的下标
              for(let k=0;k<length;k++){
                if(errorWords[i].text.length<=domObj.children[index].innerText.length) {
                  map.push({
                    docIndex: domObj.children[index].innerHTML.indexOf(domObj.children[index].innerText[k], start),
                    doc: domObj.children[index].innerHTML,
                    text: domObj.children[index].innerText[k],
                    textIndex: k
                  })
                  start = map[k].docIndex + 1;
                }else{
                  map.push({
                    docIndex: domObj.children[index].innerHTML.indexOf(errorWords[i].text[k], start),
                    doc: domObj.children[index].innerHTML,
                    text: errorWords[i].text[k],
                    textIndex: k
                  })
                  start = map[k].docIndex + 1;
                }
              }
              let mapIndex = map.findIndex(item=>{
                return item.textIndex==subscript
              })
              let continuity = map[mapIndex].docIndex;
              let childdom = domObj.children[index].innerHTML;
              let oneWord=null;
              for(let l=0;l<text.length;l++){
                if(errorWord.length===1){
                  let obj={};
                  map.map(item=>{
                    if(item.text===errorWord&&item.docIndex===continuity){
                      obj=item;
                      oneWord = item.docIndex;
                    }
                  })
                }else if(map[mapIndex+l].docIndex!==continuity&&errorWord.length>1){
                  if(errorWord.length===2){
                    childdom = childdom.substr(0, continuity) + childdom.substr(map[mapIndex+l].docIndex,1) + childdom.substr(continuity)
                  }else {
                    childdom = childdom.substr(0, continuity) + text[l] + childdom.substr(continuity)
                  }
                  childdom=childdom.substr(0,map[mapIndex+l].docIndex+1)+childdom.substr(map[mapIndex+l].docIndex+2);
                  oneWord=null;
                }
                continuity++;
              }
              domObj.children[index].innerHTML=childdom;
              domIndex=oneWord||domObj.children[index].innerHTML.indexOf(text);
            }


            // let index = dom.indexOf(text, textIndex);
            if(errorWord.length===1){
              domObj.children[index].innerHTML = domObj.children[index].innerHTML.substr(0, domIndex)+"<span style='background:red;' id=" + errorWords[i].index + ">"+errorWord+ "</span>" + domObj.children[index].innerHTML.substr(domIndex+1)
            }else {
              if(domIndex===-1){
                domIndex=domObj.children[index].innerHTML.indexOf(errorWord);
                domObj.children[index].innerHTML = (domIndex === 0 ? "" : domObj.children[index].innerHTML.substr(0, domIndex)) + "<span style='background:red;' id=" + errorWords[i].index + ">" + errorWord + "</span>" + domObj.children[index].innerHTML.substr(domIndex + errorWord.length);
              }else {
                domObj.children[index].innerHTML = (domIndex === 0 ? "" : domObj.children[index].innerHTML.substr(0, domIndex)) + (preText?preText:'') + "<span style='background:red;' id=" + errorWords[i].index + ">" + errorWord + "</span>" + (nextText?nextText:'') + domObj.children[index].innerHTML.substr(domIndex + text.length);
              }
            }
              // let reg = new RegExp(text);
              // dom = dom.replace(reg, preText + "<span style='background:red;' id=" + index + ">" + errorWord + "</span>" + nextText);
              _this.allKeys.push({...errorWords[i], index: `${errorWords[i].index}`,disabled:false});
              dom = domObj.innerHTML;
              _this.uEditor.setContent(dom);
          }
          loadingInstance1.close();
        }).catch(() => {
          loadingInstance1.close();
        })
        // let node = dom.querySelectorAll('span[data-slate-string="true"]');
        // node.forEach((element,elementIndex) => {
        //     let text = element.textContent
        //     let rel = text
        //     textCorrectionExtract({text:text}).then(res=>{
        //         if(res.code == 0){
        //             let arr = res.data.sort((a,b)=>{ return b.index-a.index})
        //             for(let i=0;i<arr.length;i++){
        //                 let item = arr[i]
        //                 let correctStyle = `<span style="background:red;" id="${elementIndex}-${item.index}">${item.error}</span>`
        //                 rel = rel.substr(0, item.index) + correctStyle + rel.substr(item.index+item.error.length)
        //                 _this.allKeys.push({...item,index:`${elementIndex}-${item.index}`})
        //             }
        //             element.innerHTML = rel
        //         }
        //     })
        // });
        _this.isloding = true
      })

    },
    toRevise() {
      this.toReviseOne(this.allKeys[0],0);
      if(this.allKeys.length>0){
        setTimeout(()=>{
          this.toRevise();
        },200)
      }
      // this.allKeys = []
    },
    toReviseOne(item, index) {
      let dom = new DOMParser().parseFromString(this.uEditor.getAllHtml(), "text/html");
      let node = dom.getElementById(`${item.index}`);
      node?.before(item.correct);
      node?.remove();
      if (index || index == 0) {
        this.allKeys.splice(index, 1);
        this.allKeys.map((obj,j)=>{
          if(item.text==obj.text&&item.error!==obj.error){
            if(item.error.indexOf(obj.error)!==-1||obj.error.indexOf(item.error)!==-1){
              this.allKeys[j]={
                ...obj,
                disabled:true
              };
              let node = dom.getElementById(`${obj.index}`);
              node?.before(node.innerHTML);
              node?.remove();
            }
          }
        })
      }
      this.activeIndex=null;
      this.uEditor.setContent(dom.body.innerHTML);
      this.isChange = true;
    },
    toSave() {
      // let dom = this.editor.getEditableContainer()
      // this.editor.select([]);
      // this.editor.deleteFragment();
      // this.editor.dangerouslyInsertHtml(dom.innerHTML)
      // let html = this.editor.getHtml()
      this.activeIndex=null;
      let dom = new DOMParser().parseFromString(this.uEditor.getAllHtml(), "text/html");
      this.allKeys.forEach((item) => {
        let node = dom.getElementById(`${item.index}`);
        // node.style = "background:none;"
        node?.before(node.innerText);
        node?.remove();
      })
      this.uEditor.setContent(dom.body.innerHTML);
      if (this.isChange) {
        let html = this.uEditor.getContent();
        this.$emit('saveMisse', html)
      } else {
        this.close()
      }
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .edui-editor-toolbarbox .edui-default {
  display: none;
}

/deep/ iframe {
  height: 400px;
  overflow: auto;
}

.content {
  display: flex;

  .left {
    width: 688px;
    .title {
      /deep/ .el-input {
        border-bottom: 1px solid #eeebeb;
        padding: 10px 0;
      }

      /deep/ .el-input__inner {
        border: none;
        color: #303133;
        font-size: 21px;
        font-weight: bold;

      }

      /deep/ input::-webkit-input-placeholder {
        color: #303133;
        font-size: 21px;
        font-weight: bold;
      }
    }

    .abstract {
      padding: 10px 0;
      border-bottom: 1px solid #eeebeb;

      /deep/ input::-webkit-input-placeholder {
        color: #415058;
        font-size: 14px;
      }

      /deep/ .el-input__inner {
        border: none;
      }
    }

    .article {
      margin-top: 30px;

      /deep/ .el-textarea__inner {
        border: none;
      }

      .error-bg {
        background: red !important;
      }
    }
  }

  .rgith {
    width: 462px;
    margin-left: 30px;
    // border: 1px solid #d9d9d9;
    /deep/ .el-button {
      border: none;
      padding: 10px 0;
      color: #1890ff;
    }

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: #b2b2b2;
      border-radius: 32px;
      transition: all .2s;

      &:hover {
        background: rgba(178, 178, 178, 0.8);
      }
    }

    ::-webkit-scrollbar-track {
      background: #e1e1e1;
      border-radius: 32px;
    }

    .tips {
      color: #101010;
      height: 56px;
      line-height: 56px;
      border-radius: 6px 6px 0px 0px;
      background-color: #f7f7f7;
      border: 1px solid #d9d9d9;
      padding: 0 10px;
    }

    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      flex-wrap: nowrap;
      border-bottom: 1px solid #d9d9d9;

      .count {
        color: red;
      }
    }
    .normal{
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      padding: 10px;
      margin-bottom: 10px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #eeeeef;
      //box-shadow: 0 3px 7px #e3e9ff;
      &:hover{
        background-color: #f7f7f7;
        //box-shadow: 0 0 4px rgba(0,0,0,.1)
      }
    }

    .item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #f7f7f7;
      border: 1px solid #eeeeef;
      box-shadow: 0 0 4px rgba(0,0,0,.2);
      padding: 10px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .top{
      font-size: 14px;
      font-weight: 700;
      color: #000;
    }
    .bottom{
      margin-top: 5px;
      font-size: 12px;
      color: #909399;
    }
    .mini{
      font-size: 14px;
      //font-weight: 700;
      color: #409eff;
      &:hover{
        color: #1061b5;
        font-weight: 700;
      }
    }
  }

}

/deep/ .edui-default .edui-editor-iframeholder {
  height: fit-content !important;
}
</style>